import React from 'react';
import { Card } from './ui/Card';
import { Monitor, TrendingUp, Check } from 'lucide-react';
export function UniqueValue() {
  return <section className="py-20 bg-[#0A0E27] relative overflow-hidden" data-id="element-201" data-mp="3gtbagqyju6ic">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#141B3A]/50 to-transparent -z-10" data-id="element-202" data-mp="3bw1bokp9sihu"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203" data-mp="37sd3q0wq7kw2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-204" data-mp="8ej3ud9hzbhf">
          <div data-id="element-205" data-mp="3h14nela8amm">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-206" data-mp="3h9f6ztxn3un">
              IT + Sales ={' '}
              <span className="text-[#FF5722]" data-id="element-207" data-mp="3vi7hckovddhd">Your Advantage</span>
            </h2>
            <p className="text-lg text-[#94A3B8] mb-8 leading-relaxed" data-id="element-208" data-mp="3qjw37xrjkgtc">
              Most CRM consultants are either pure technicians who don't
              understand sales, or salespeople without deep technical knowledge.
              I combine both.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-209" data-mp="18h3no3t7kfkt">
              <div className="flex items-start gap-4" data-id="element-210" data-mp="18fsji2vup5t6">
                <div className="w-12 h-12 rounded-lg bg-blue-500/10 flex items-center justify-center flex-shrink-0" data-id="element-211" data-mp="1dfewcb7rok1g">
                  <Monitor className="w-6 h-6 text-blue-500" data-id="element-212" data-mp="zgnk6ucgt8fy" />
                </div>
                <div data-id="element-213" data-mp="14ep57ktgbhu2">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-214" data-mp="14i4kann4kqvh">
                    IT & Development
                  </h3>
                  <ul className="space-y-2 text-[#94A3B8]" data-id="element-215" data-mp="uhkdz6kr0w6e">
                    <li className="flex items-center gap-2" data-id="element-216" data-mp="uj59ozisul5u">
                      <Check className="w-4 h-4 text-blue-500" data-id="element-217" data-mp="gr8lh6k94veq" />
                      Programming (PHP, JS, Python)
                    </li>
                    <li className="flex items-center gap-2" data-id="element-218" data-mp="ksaolyhahrlz">
                      <Check className="w-4 h-4 text-blue-500" data-id="element-219" data-mp="6tavoemquqk0" />
                      Complex Web Applications
                    </li>
                    <li className="flex items-center gap-2" data-id="element-220" data-mp="bqkxyuv8ewp9">
                      <Check className="w-4 h-4 text-blue-500" data-id="element-221" data-mp="2dhjxuv4po8uv" />
                      Professional IT Architecture
                    </li>
                  </ul>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-222" data-mp="24p9mhai2xxc1">
                <div className="w-12 h-12 rounded-lg bg-[#FF5722]/10 flex items-center justify-center flex-shrink-0" data-id="element-223" data-mp="1zp3s3mkfdwq9">
                  <TrendingUp className="w-6 h-6 text-[#FF5722]" data-id="element-224" data-mp="2wfw9cnj3hutm" />
                </div>
                <div data-id="element-225" data-mp="2se2ben0ab4x5">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-226" data-mp="2sdj4s2g342yf">
                    Sales & Practice
                  </h3>
                  <ul className="space-y-2 text-[#94A3B8]" data-id="element-227" data-mp="2nd4useuxaixr">
                    <li className="flex items-center gap-2" data-id="element-228" data-mp="2ig4qo9hmvq9a">
                      <Check className="w-4 h-4 text-[#FF5722]" data-id="element-229" data-mp="2ihz9ni9ch8aq" />3 Years Active
                      Sales Experience
                    </li>
                    <li className="flex items-center gap-2" data-id="element-230" data-mp="1706j6a23tca6">
                      <Check className="w-4 h-4 text-[#FF5722]" data-id="element-231" data-mp="172sos45fphpr" />
                      B2B and B2C Expertise
                    </li>
                    <li className="flex items-center gap-2" data-id="element-232" data-mp="11ut1qia3n35d">
                      <Check className="w-4 h-4 text-[#FF5722]" data-id="element-233" data-mp="11t9h6fheu5xs" />
                      Built Own Sales Team
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="relative" data-id="element-234" data-mp="1fnipar5a0g4l">
            <Card className="p-8 border-[#334155] bg-[#141B3A]/80 backdrop-blur-sm" data-id="element-235" data-mp="1fmh9yah897h2">
              <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-236" data-mp="1kkslqqr31s1x">
                The Result
              </h3>
              <div className="space-y-4" data-id="element-237" data-mp="1plydal90b99v">
                <div className="p-4 rounded-lg bg-[#0A0E27] border border-[#1E293B] flex items-center justify-between" data-id="element-238" data-mp="1ukt8kmo5uqav">
                  <span className="text-[#94A3B8]" data-id="element-239" data-mp="3rdlbb6rbg4fu">Technically Robust</span>
                  <span className="text-green-500 font-bold" data-id="element-240" data-mp="5z3r31h7htp">100%</span>
                </div>
                <div className="p-4 rounded-lg bg-[#0A0E27] border border-[#1E293B] flex items-center justify-between" data-id="element-241" data-mp="1qn3yomvifk03">
                  <span className="text-[#94A3B8]" data-id="element-242" data-mp="1lp2etzq9fgnk">Practically Usable</span>
                  <span className="text-green-500 font-bold" data-id="element-243" data-mp="1znsenn4grufm">100%</span>
                </div>
                <div className="p-4 rounded-lg bg-[#0A0E27] border border-[#1E293B] flex items-center justify-between" data-id="element-244" data-mp="1uoxv2iyoa1ug">
                  <span className="text-[#94A3B8]" data-id="element-245" data-mp="16yv4y8ebj5yh">Team Adoption</span>
                  <span className="text-green-500 font-bold" data-id="element-246" data-mp="12xrslvvhbs20">High</span>
                </div>
              </div>
              <div className="mt-8 text-center" data-id="element-247" data-mp="1gowlmf4cdm3d">
                <p className="text-white font-medium mb-2" data-id="element-248" data-mp="1gqr5dq3vn85v">
                  "No theory – only practice."
                </p>
                <p className="text-sm text-[#94A3B8]" data-id="element-249" data-mp="1bwmzla6cl66d">
                  Every feature was tested and optimized in real-world use.
                </p>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}